
<script setup lang="ts">
export interface CardButtonProps {
    data: {
        cards: CardButton[]
    }
}

export interface CardButton {
    card_title: string
    card_cta:   string
    card_image: string
    card_in_new_window: string
}

const props = defineProps<CardButtonProps>()
</script>

<template>
  <div class="w-100">
    <ScrollSection class="g-6 justify-content-lg-center px-7 pb-10">
      <ScrollSectionItem
        v-for="(card, index) in props.data.cards"
        :key="`card-${index}`"
        class="col-8 col-md-4 col-lg-2"
      >
        <div
          class="card-button rounded px-2 py-10 box-shadow-1 h-100 text-center w-100 d-flex flex-column align-items-center justify-content-center position-relative"
          :class="{ 'card-button--linked': card.card_cta }"
        >
          <img
            :src="card.card_image"
            :width="24"
            :height="24"
            loading="lazy"
            decoding="async"
            alt=""
            class="d-block mx-auto mb-5 card-button__icon"
          >
          <span class="fs-bigger mb-0 fw-semibold">
            {{ card.card_title }}
          </span>

          <svg
            v-if="card.card_in_new_window === '1'"
            class="d-block flex-shrink-0 position-absolute card-button__external-icon"
            width="16"
            height="16"
          >
            <use xlink:href="#external" />
            <title>{{ $t('Odkaz sa otvára v novom okne') }}</title>
          </svg>
          <a
            v-if="card.card_cta"
            :href="card.card_cta"
            :target="card.card_in_new_window === '1' ? '_blank' : '_self'"
            :aria-label="card.card_title"
            class="stretched-link"
          />
        </div>
      </ScrollSectionItem>
    </ScrollSection>
  </div>
</template>

<style scoped lang="scss">
.card-button {
    background-color: var(--global-color-white);
    color: var(--global-color-black-100);
    max-height: 17rem;
    transition: var(--btn-transition);

    &--linked:hover {
        background-color: var(--global-color-secondary);
        transform: translateY(-1rem);
        color: var(--global-color-white);

        .card-button__icon {
            filter: brightness(0) invert(1);
        }

        svg {
            fill: var(--global-color-white);
        }
    }

    &__external-icon {
        top: 1.5rem;
        right: 1.5rem;
    }
}
</style>
